import {
  Page_Pagebuilder_Blocks_Checklist_Links,
  Page_Pagebuilder_Blocks_Texteditor_Links,
} from '@/graphql/generated/graphql';
import ButtonLink from './ButtonLink';
import type { MouseEventHandler } from 'react';

type LinksProps = {
  onLinkClick?: MouseEventHandler<HTMLAnchorElement>;
  links:
    | Page_Pagebuilder_Blocks_Texteditor_Links[]
    | Page_Pagebuilder_Blocks_Checklist_Links[];
};

const Links = ({ links, onLinkClick }: LinksProps) => {
  if (!links || links.length === 0) return null;
  return (
    <div className="flex flex-wrap justify-center gap-4 lg:gap-8 mt-14">
      {links.map((item, i) => (
        <ButtonLink
          key={i}
          onClick={onLinkClick}
          type={item.linkType as 'default' | 'outline'}
          url={item.link}
          linkInNewWindow={item.linkInNewWindow}
          text={item.linkText}
        />
      ))}
    </div>
  );
};

export default Links;
